<template>
  <div class="publish-page">

    <!-- ═══════════════════ HERO ═══════════════════ -->
    <section class="publish-hero">
      <div class="container hero-content">
        <div class="row align-items-center g-5">
          <div class="col-lg-6">
            <div class="hero-badge mb-3">
              <i class="fa-solid fa-arrows-spin me-2"></i>
              {{ $t('publish.portalBadge') }}
            </div>
            <h1 class="hero-title" v-html="$t('publish.title')"></h1>
            <p class="hero-description mt-3" v-html="$t('publish2.activityIntro')"></p>
          </div>
          <div class="col-lg-6 d-none d-lg-block">
            <div class="hero-image-wrapper">
              <img src="../assets/images/home/apren-publicar.png" alt="Com publicar a Aprèn" class="hero-image" />
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- ═══════════════════ 1. PUBLICACIÓ D'ACTIVITATS (Blue Gradient) ═══════════════════ -->
    <section class="sources-fullwidth" id="sources">
      <div class="container">
        <div class="section-header mb-5">
          <div class="section-icon-wrap icon-light">
            <i class="fa-solid fa-database"></i>
          </div>
          <div>
            <h2 class="section-title section-title-light">1. {{ $t('publish2.activityTitle') }}</h2>
            <p class="body-text-light mt-2" v-html="$t('publish2.activityIntro')"></p>
          </div>
        </div>

        <div class="integrated-tabs">
          <ul class="nav nav-tabs border-0 mb-4" role="tablist">
            <li class="nav-item">
              <button class="nav-link active" id="up-tab" data-bs-toggle="pill" data-bs-target="#up" type="button" role="tab">
                {{ $t('publish2.tabs.upcommons') }}
              </button>
            </li>
            <li class="nav-item">
              <button class="nav-link" id="pr-tab" data-bs-toggle="pill" data-bs-target="#pr" type="button" role="tab">
                {{ $t('publish2.tabs.prisma') }}
              </button>
            </li>
            <li class="nav-item">
              <button class="nav-link" id="dr-tab" data-bs-toggle="pill" data-bs-target="#dr" type="button" role="tab">
                {{ $t('publish2.tabs.drac') }}
              </button>
            </li>
          </ul>

          <div class="tab-content integrated-content">
            <!-- UPCommons -->
            <div class="tab-pane fade show active" id="up" role="tabpanel">
              <div class="integrated-panel">
                <p class="body-text-light mb-4" v-html="$t('publish2.upcommons.intro')"></p>
                <div class="integrated-list mb-5">
                  <div class="integrated-item" v-for="(item, idx) in $tm('publish2.upcommons.structure')" :key="idx">
                    <i class="fa-solid fa-check me-3"></i>
                    <span v-html="$rt(item)"></span>
                  </div>
                </div>
                <h4 class="integrated-subtitle mb-4" v-html="$t('publish2.upcommons.publishedTitle')"></h4>
                <div class="integrated-badges">
                  <div class="integrated-badge" v-for="(badge, key) in $tm('publish2.upcommons.collections')" :key="key">
                    <i class="fa-solid fa-layer-group me-2 opacity-50"></i>
                    <span v-html="$rt(badge)"></span>
                  </div>
                </div>
              </div>
            </div>

            <!-- PRISMA -->
            <div class="tab-pane fade" id="pr" role="tabpanel">
              <div class="integrated-panel">
                <p class="body-text-light mb-4" v-html="$t('publish2.prisma.intro')"></p>
                <div class="integrated-list mb-5">
                  <div class="integrated-item" v-for="(item, idx) in $tm('publish2.prisma.structure')" :key="idx">
                    <i class="fa-solid fa-check me-3"></i>
                    <span v-html="$rt(item)"></span>
                  </div>
                </div>
                <h4 class="integrated-subtitle mb-4" v-html="$t('publish2.prisma.publishedTitle')"></h4>
                <div class="integrated-badges">
                  <div class="integrated-badge" v-for="(badge, key) in $tm('publish2.prisma.badges')" :key="key">
                    <i class="fa-solid fa-layer-group me-2 opacity-50"></i>
                    <span v-html="$rt(badge)"></span>
                  </div>
                </div>
              </div>
            </div>

            <!-- DRAC -->
            <div class="tab-pane fade" id="dr" role="tabpanel">
              <div class="integrated-panel">
                <p class="body-text-light mb-4" v-html="$t('publish2.drac.intro')"></p>
                <div class="integrated-list mb-4">
                  <div class="integrated-item" v-for="(item, idx) in $tm('publish2.drac.structure')" :key="idx">
                    <i class="fa-solid fa-check me-3"></i>
                    <span v-html="$rt(item)"></span>
                  </div>
                </div>
                <h4 class="integrated-subtitle mb-4" v-html="$t('publish2.drac.publishedTitle')"></h4>
                <div class="integrated-badges">
                  <div class="integrated-badge" v-for="(badge, key) in $tm('publish2.drac.badges')" :key="key">
                    <i class="fa-solid fa-layer-group me-2 opacity-50"></i>
                    <span v-html="$rt(badge)"></span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- ═══════════════════ 2. INTEGRACIÓ AMB ATENEA (Neutral) ═══════════════════ -->
    <section class="container content-section" id="deposit">
      <div class="section-header mb-5">
        <div class="section-icon-wrap icon-blue">
          <i class="fa-solid fa-file-export"></i>
        </div>
        <div>
          <h2 class="section-title">2. {{ $t('publish.depositTitle') }}</h2>
          <p class="body-text mt-2" v-html="$t('publish.deposit1') + ' ' + $t('publish.deposit2')"></p>
        </div>
      </div>

      <!-- Pasos en cuadrícula de 3 columnas -->
      <div class="steps-grid">
        <div class="step-column-card" v-for="step in [1,2,3,4,5]" :key="step">
          <div class="step-column-header">
            <span class="step-num">{{ step }}</span>
            <h3 class="step-column-title" v-html="$t('publish.step' + step)"></h3>
          </div>
          
          <div class="step-column-img-wrap" @click="openModal(require(`@/assets/images/publish/publish${step}.png`))">
            <img :src="require(`@/assets/images/publish/publish${step}.png`)" :alt="$t('publish.step' + step + 'Alt')" class="step-column-img" />
            <div class="column-img-overlay"><i class="fa-solid fa-magnifying-glass-plus"></i></div>
          </div>

          <div class="step-column-body mt-3">
            <div v-if="step === 4" class="column-extra-notes">
               <div v-for="i in 3" :key="i" class="column-note">
                 <i class="fa-solid fa-circle-info me-2 text-apren-blue"></i>
                 <span v-html="getStep4NoteTranslation(i)"></span>
               </div>
            </div>
            <div v-if="step === 5" class="column-status-box">
              <div class="column-status-grid">
                <div class="column-status-pill" v-for="st in ['pending', 'sent', 'review', 'rejected', 'published']" :key="st">
                   <i class="fa-solid fa-circle status-dot" :class="'dot-' + st"></i>
                   <span v-html="$t('publish.status.' + st)"></span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- ═══════════════════ 3. CONTACTE (Grey/Neutral) ═══════════════════ -->
    <section class="contact-section-neutral" id="contact">
      <div class="container">
        <div class="section-header mb-5">
          <div class="section-icon-wrap icon-indigo">
            <i class="fa-solid fa-comments"></i>
          </div>
          <div>
            <h2 class="section-title">3. {{ $t('publish.contactTitle') }}</h2>
            <p class="body-text mt-2" v-html="$t('publish.contactIntro')"></p>
          </div>
        </div>

        <div class="libraries-grid-neutral">
          <div class="lib-card-plain" v-for="(lib, key) in libraries" :key="key">
            <div class="lib-header-plain">
               <h4 class="lib-name-plain"><a :href="'https://bibliotecnica.upc.edu/' + lib.url" target="_blank">{{ lib.name }}</a></h4>
            </div>
            <div class="lib-body-plain">
               <div class="lib-person"><i class="fa-solid fa-user me-2"></i> {{ lib.person }}</div>
               <div class="lib-email"><i class="fa-solid fa-envelope me-2"></i> <a :href="'mailto:' + lib.email">{{ lib.email }}</a></div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Image Zoom Modal -->
    <div class="modal fade" id="imageModal" tabindex="-1" aria-hidden="true">
      <div class="modal-dialog modal-xl modal-dialog-centered">
        <div class="modal-content border-0 bg-transparent shadow-none">
          <div class="modal-header border-0 p-0 justify-content-end mb-2">
            <button type="button" class="btn-close btn-close-white fs-5" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body p-0 text-center">
            <img :src="selectedImage" class="img-fluid rounded-4 shadow-lg border border-light-subtle" v-if="selectedImage" alt="Zoomed view">
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import { defineComponent, onMounted, ref } from 'vue';
import { useRoute } from 'vue-router';
import { useI18n } from 'vue-i18n';
import store from "@/store";
import { Modal } from 'bootstrap';

export default defineComponent({
  name: 'Publish2View',
  setup() {
    const route = useRoute();
    const { t, tm, rt } = useI18n();
    const selectedImage = ref(null);

    const openModal = (imgUrl) => {
      selectedImage.value = imgUrl;
      const modalElement = document.getElementById('imageModal');
      if (modalElement) {
        const modal = new Modal(modalElement);
        modal.show();
      }
    };

    const libraries = {
      brgf: { name: 'Biblioteca Rector Gabriel Ferraté', email: 'montse.moragas@upc.edu', person: 'Montse Moragas', url: 'brgf' },
      bct: { name: 'Biblioteca del Campus de Terrassa', email: 'isabel.molinos@upc.edu', person: 'Isabel Molinos', url: 'bct' },
      bcbl: { name: 'Biblioteca del Campus del Baix Llobregat', email: 'gemma.garcia@upc.edu', person: 'Gemma García', url: 'bcbl' },
      bcum: { name: 'Biblioteca del Campus Universitari de Manresa', email: 'conxa.moncunill@upc.edu', person: 'Conxa Moncunill', url: 'bcum' },
      etseib: { name: 'Biblioteca de l\'Escola Tècnica Superior d\'Enginyeria Industrial de Barcelona', email: 'margarita.anglada@upc.edu', person: 'Margarita Anglada', url: 'etseib' },
      etsab: { name: 'Biblioteca Oriol Bohigas de l\'Escola Tècnica Superior d\'Arquitectura de Barcelona', email: 'fani.diaz@upc.edu', person: 'Fani Díaz', url: 'etsab' },
      eebe: { name: 'Biblioteca de l\'Escola d\'Enginyeria de Barcelona Est', email: 'marina.casadevall@upc.edu', person: 'Marina Casadevall', url: 'eebe' },
      epseb: { name: 'Biblioteca de l\'Escola Politècnica Superior d\'Edificació de Barcelona', email: 'rosalia.ordonez@upc.edu', person: 'Rosalía Ordóñez', url: 'epseb' },
      epsevg: { name: 'Biblioteca de l\'Escola Politècnica Superior d\'Enginyeria de Vilanova i la Geltrú', email: 'tais.bages@upc.edu', person: 'Taïs Bagés', url: 'epsevg' },
      etsav: { name: 'Biblioteca de l\'Escola Tècnica Superior d\'Arquitectura del Vallès', email: 'angel.beumala@upc.edu', person: 'Àngel Beumala', url: 'etsav' },
      fme: { name: 'Biblioteca de la Facultat de Matemàtiques i Estadística', email: 'sara.matheu@upc.edu', person: 'Sara Matheu', url: 'fme' },
      fnb: { name: 'Biblioteca de la Facultat de Nàutica de Barcelona', email: 'manel.mendoza@upc.edu', person: 'Manel Mendoza', url: 'fnb' }
    };

    const getBenefitIcon = (index) => {
      const icons = [
        'fa-solid fa-id-card-clip',
        'fa-solid fa-shield-halved',
        'fa-solid fa-creative-commons',
        'fa-solid fa-bullhorn',
        'fa-solid fa-chart-line',
        'fa-solid fa-link'
      ]
      return icons[index - 1] || 'fa-solid fa-check-circle'
    }

    const getBenefitTranslation = (index) => {
      try { return t(`publish.benefits.${index}`); } catch (e) { return ''; }
    };

    const getStep4NoteTranslation = (index) => {
      try { return t(`publish.step4Notes.${index}`); } catch (e) { return ''; }
    };

    onMounted(async () => {
      await store.dispatch('updateSearchSelected', "Tots");
      await store.dispatch('updateBackgroundImage', { 
        view: route.name, 
        url: require('@/assets/images/sections/banner-blue.webp') 
      });
    });

    return {
      libraries,
      getBenefitTranslation,
      getStep4NoteTranslation,
      getBenefitIcon,
      tm,
      rt,
      selectedImage,
      openModal
    };
  }
});
</script>

<style scoped>
/* ════════════════════════════════════════════════
   GENERAL & VARIABLES
════════════════════════════════════════════════ */
.publish-page {
  --apren-900: #0c2340;
  --apren-800: #0d3160;
  --apren-700: #0a4a8a;
  --apren-600: #007BC1;
  --apren-500: #0a66c2;
  --apren-400: #1e90d4;
  --apren-300: #38b6e8;
  --apren-200: #a8d8f0;
  --apren-100: #dff0fb;
  
  --text-primary: #0c2340;
  --text-secondary: #4a5568;
  --border: #e2e8f0;
  --bg-light: #f8fafc;
  
  font-family: 'Roboto', Helvetica, serif;
  color: var(--text-primary);
  background: white;
  margin-top: -1.5rem;
}

.content-section {
  padding: 5rem 0;
}

.body-text {
  font-size: 18px;
  font-weight: 300;
  line-height: 28px;
  color: var(--text-secondary);
}

/* ════════════════════════════════════════════════
   SECTION HEADERS
════════════════════════════════════════════════ */
.section-header {
  display: flex;
  align-items: flex-start;
  gap: 1.5rem;
}

.section-icon-wrap {
  flex-shrink: 0;
  width: 54px;
  height: 54px;
  border-radius: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.5rem;
  box-shadow: 0 4px 12px rgba(0,0,0,0.05);
}

.icon-blue { background: #e0f2fe; color: var(--apren-500); }
.icon-indigo { background: #e0e7ff; color: #4f46e5; }
.icon-light { background: rgba(255,255,255,0.2); color: white; border: 1px solid rgba(255,255,255,0.3); }

.section-title {
  font-size: 2.25rem;
  font-weight: 800;
  color: var(--text-primary);
  margin: 0;
  letter-spacing: -0.02em;
}

.section-title-light { color: white; }

/* ════════════════════════════════════════════════
   HERO
════════════════════════════════════════════════ */
.publish-hero {
  background: white;
  padding: 4rem 0 3rem;
  overflow: hidden;
}

.hero-badge {
  display: inline-flex;
  align-items: center;
  background: var(--apren-100);
  border: 1px solid var(--apren-200);
  color: var(--apren-700);
  font-size: 0.75rem;
  font-weight: 500;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  padding: 0.35rem 1rem;
  border-radius: 50px;
}

.hero-image-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
}

.hero-image {
  width: 100%;
  max-width: 500px;
  border-radius: 20px;
  box-shadow: 0 16px 48px rgba(10, 102, 194, 0.18);
  object-fit: cover;
}

.hero-title {
  font-size: clamp(2rem, 5vw, 3rem);
  font-weight: 800;
  line-height: 1.1;
  color: var(--text-primary);
}

.hero-description {
  font-size: 18px;
  line-height: 28px;
  color: var(--text-secondary);
  font-weight: 300;
}



/* ════════════════════════════════════════════════
   STEPS GRID (Atenea Integration)
════════════════════════════════════════════════ */
.steps-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 2rem;
}

.step-column-card {
  display: flex;
  flex-direction: column;
  background: white;
  border: 1px solid var(--border); /* El borde de "un punto" pedido */
  border-radius: 20px;
  padding: 1.5rem;
  height: 100%;
  transition: all 0.3s ease;
  box-shadow: 0 2px 8px rgba(0,0,0,0.02);
}

.step-column-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 12px 30px rgba(0,0,0,0.08);
  border-color: var(--apren-400);
}

.step-num {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: var(--apren-500);
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 800;
  flex-shrink: 0;
  font-size: 1rem;
}

.step-column-header {
  display: flex;
  gap: 1rem;
  align-items: flex-start;
  margin-bottom: 1.25rem;
}

.step-column-title {
  font-size: 18px;
  font-weight: 700;
  line-height: 1.3;
  color: var(--text-primary);
  margin: 0;
}

.step-column-img-wrap {
  position: relative;
  border-radius: 12px;
  overflow: hidden;
  border: 1px solid var(--border);
  cursor: pointer;
  background: white;
  width: 100%;
  max-width: 280px; /* Tamaño reducido como pidió el usuario */
  margin: 0 auto;
}

.step-column-img {
  width: 100%;
  height: 160px; /* Altura fija contenida */
  object-fit: contain; /* Para que la imagen se vea entera sin cortarse */
  background: #fdfdfd;
  transition: transform 0.4s;
}

.column-img-overlay {
  position: absolute;
  top: 0; left: 0; right: 0; bottom: 0;
  background: rgba(0, 123, 193, 0.4);
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 1.5rem;
  opacity: 0;
  transition: opacity 0.3s;
}

.step-column-img-wrap:hover .column-img-overlay { opacity: 1; }
.step-column-img-wrap:hover .step-column-img { transform: scale(1.08); }

.column-note {
  font-size: 16px;
  font-weight: 300;
  line-height: 1.5;
  margin-bottom: 0.75rem;
  color: var(--text-secondary);
}

.column-status-grid {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.column-status-pill {
  font-size: 16px;
  font-weight: 300;
  display: flex;
  align-items: center;
  gap: 0.6rem;
  color: var(--text-secondary);
}

.status-dot { font-size: 0.6rem; }
.dot-pending { color: #94a3b8; }
.dot-sent { color: #10b981; }
.dot-review { color: #3b82f6; }
.dot-rejected { color: #ef4444; }
.dot-published { color: #0ea5e9; }

/* ════════════════════════════════════════════════
   SOURCES BLUE GRADIENT (Integrated Tabs)
════════════════════════════════════════════════ */
.sources-fullwidth {
  background: linear-gradient(135deg, #0c2340 0%, #0d3d6b 45%, #0a66c2 100%);
  padding: 5rem 0;
  margin-left: calc(-50vw + 50%);
  margin-right: calc(-50vw + 50%);
  padding-left: calc(50vw - 50%);
  padding-right: calc(50vw - 50%);
  color: white;
}

.body-text-light {
  font-size: 18px;
  font-weight: 300;
  line-height: 28px;
  color: rgba(255, 255, 255, 0.9);
}

.integrated-tabs .nav-tabs {
  gap: 2rem;
}

.integrated-tabs .nav-link {
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.1);
  color: rgba(255, 255, 255, 0.7);
  font-size: 18px;
  font-weight: 700;
  padding: 0.6rem 1.4rem;
  border-radius: 12px;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  margin-right: 0.5rem;
}

.integrated-tabs .nav-link:hover {
  background: rgba(255, 255, 255, 0.12);
  color: white;
}

.integrated-tabs .nav-link.active {
  background: white;
  color: var(--apren-500);
  box-shadow: 0 8px 20px rgba(0, 35, 64, 0.2);
  border-color: white;
}

.integrated-panel {
  padding-top: 1rem;
}

.integrated-list {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.integrated-item {
  display: flex;
  align-items: center;
  font-size: 18px;
  font-weight: 300;
}

.integrated-subtitle {
  font-size: 20px;
  font-weight: 700;
  color: white;
}

.integrated-badges {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  align-items: flex-start;
}

.integrated-badge {
  background: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.15);
  padding: 0.6rem 1.4rem;
  border-radius: 12px;
  font-weight: 300;
  font-size: 17px;
  transition: all 0.2s;
}

.integrated-badge:hover {
  background: rgba(255, 255, 255, 0.18);
  transform: translateX(4px);
}

/* ════════════════════════════════════════════════
   CONTACT NEUTRAL
════════════════════════════════════════════════ */
.contact-section-neutral {
  padding: 5rem 0;
  background: #f8fafc;
  margin-left: calc(-50vw + 50%);
  margin-right: calc(-50vw + 50%);
  padding-left: calc(50vw - 50%);
  padding-right: calc(50vw - 50%);
}

.libraries-grid-neutral {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 2rem;
}

.lib-card-plain {
  padding-bottom: 1.5rem;
  border-bottom: 1px solid #e2e8f0;
}

.lib-name-plain { font-size: 18px; font-weight: 700; margin: 0 0 0.5rem 0; }
.lib-name-plain a { color: var(--text-primary); text-decoration: none; }
.lib-name-plain a:hover { color: var(--apren-500); }

.lib-person { font-size: 16px; font-weight: 300; color: var(--text-secondary); }
.lib-email { font-size: 16px; font-weight: 400; }
.lib-email a { color: var(--apren-500); text-decoration: none; }

/* Utils */
.btn-apren-primary { background: var(--apren-500); color: white; border-radius: 12px; font-weight: 600; }
.btn-apren-primary:hover { background: var(--apren-400); color: white; transform: translateY(-2px); }
.btn-outline-apren { border: 2px solid var(--apren-500); color: var(--apren-500); border-radius: 12px; font-weight: 600; }

@media (max-width: 992px) {
  .steps-grid, .libraries-grid-neutral { grid-template-columns: repeat(2, 1fr); }
}

@media (max-width: 576px) {
  .steps-grid, .libraries-grid-neutral { grid-template-columns: 1fr; }
}
</style>

